export default __webpack_public_path__ + "static/media/strategic3.1252e176.png";